import { Action } from "redux";
import {
  AddAppNotificationRequest,
  HiddenAppNotificationRequest,
} from "../request/app_notification_message_request";
import {
  AddAppNotificationResponse,
  HiddenAppNotificationResponse,
} from "../response/app_notification_message_response";

export enum AppNotificationMessageActionType {
  REQUEST_ADD = "APP_NOTIFICATION_REQUEST_ADD",
  CALLBACK_ADD = "APP_NOTIFICATION_CALLBACK_ADD",

  REQUEST_HIDDEN = "APP_NOTIFICATION_REQUEST_HIDDEN",
  CALLBACK_HIDDEN = "APP_NOTIFICATION_CALLBACK_HIDDEN",
}

export interface IRequestAddAction extends Action {
  type: AppNotificationMessageActionType.REQUEST_ADD;
  item: AddAppNotificationRequest;
}
export interface ICallbackAddAction extends Action {
  type: AppNotificationMessageActionType.CALLBACK_ADD;
  isSuccess: boolean;
  item?: AddAppNotificationResponse;
}

export interface IRequestHiddenAction extends Action {
  type: AppNotificationMessageActionType.REQUEST_HIDDEN;
  item: HiddenAppNotificationRequest;
}
export interface ICallbackHiddenAction extends Action {
  type: AppNotificationMessageActionType.CALLBACK_HIDDEN;
  isSuccess: boolean;
  item?: HiddenAppNotificationResponse;
}

export type AppNotificationMessageAction =
  | IRequestAddAction
  | ICallbackAddAction
  | IRequestHiddenAction
  | ICallbackHiddenAction;

export interface IAppNotificationMessageActionCreator {
  requestAddAction(item: AddAppNotificationRequest): IRequestAddAction;
  callbackAddAction(
    isSuccess: boolean,
    item?: AddAppNotificationResponse
  ): ICallbackAddAction;

  requestHiddenAction(item: HiddenAppNotificationRequest): IRequestHiddenAction;
  callbackHiddenAction(
    isSuccess: boolean,
    item?: HiddenAppNotificationResponse
  ): ICallbackHiddenAction;
}

class ActionCreator implements IAppNotificationMessageActionCreator {
  public requestAddAction = (
    item: AddAppNotificationRequest
  ): IRequestAddAction => {
    return {
      type: AppNotificationMessageActionType.REQUEST_ADD,
      item,
    };
  };
  public callbackAddAction = (
    isSuccess: boolean,
    item?: AddAppNotificationResponse
  ): ICallbackAddAction => {
    return {
      type: AppNotificationMessageActionType.CALLBACK_ADD,
      isSuccess,
      item,
    };
  };

  public requestHiddenAction = (
    item: HiddenAppNotificationRequest
  ): IRequestHiddenAction => {
    return {
      type: AppNotificationMessageActionType.REQUEST_HIDDEN,
      item,
    };
  };
  public callbackHiddenAction = (
    isSuccess: boolean,
    item?: HiddenAppNotificationResponse
  ): ICallbackHiddenAction => {
    return {
      type: AppNotificationMessageActionType.CALLBACK_HIDDEN,
      isSuccess,
      item,
    };
  };
}

export const createAppNotificationMessageActionCreator =
  (): IAppNotificationMessageActionCreator => {
    return new ActionCreator();
  };



// WEBPACK FOOTER //
// ./src/presentation/action/app_notification_message_action.ts